import React, { PropTypes, Component } from 'react'
import ReactDOM from 'react-dom'
import debounce from 'debounce'
import $ from 'jquery'
import 'jquery.panzoom'
import 'text-spinners'
import Lyric from './Lyric'
import constants from '../constants'
import styled from 'styled-components'

const LyricsWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  user-select: none;
  display: ${props => props.displayLyric ? 'block' : 'none'};
  ${props => props.animating && props.active === constants.SHOW_LYRIC &&
    'animation: from-background 0.5s ease-in-out both;'}
  ${props => props.animating && props.active === constants.SHOW_OVERLAY &&
    'animation: to-background 0.5s ease-in-out both;'}
  > div {
    animation: fade-in 0.3s ease-in-out both 0.25s;
  }
`
const Loading = styled.span`
  position: fixed;
  top: 50%;
  left: 50%;
  color: #999;
`

class Lyrics extends Component {
  constructor () {
    super()
    this.state = {loaded: false}
    this.positionLyric = this.positionLyric.bind(this)
    this.onZoom = debounce(this.onZoom.bind(this), 5)
    this.onResize = debounce(this.onResize.bind(this), 200)
  }
  componentDidMount () {
    this.$container = $(ReactDOM.findDOMNode(this.refs.container))
    this.panzoom = $(ReactDOM.findDOMNode(this.refs.image)).panzoom({
      contain: false, maxScale: 0.75, onZoom: (e, panzoom) => { this.scale = panzoom.scale }
    })
    this.panzoom.parent().on('dblclick', this.onZoom)
    window.addEventListener('resize', this.onResize)

    this.image = new window.Image()
    $(this.image).on('load', () => {
      this.setState({loaded: true, src: this.image.src, width: this.image.width, height: this.image.height}, () => {
        window.setTimeout(this.onResize, 300)
      })
    })
    this.loadImage(this.props.lyric)
  }
  componentWillReceiveProps (props) {
    if (this.props.lyric !== props.lyric) {
      this.loadImage(props.lyric)
    }
  }
  loadImage (src) {
    this.setState({loaded: false}, () => {
      this.image.src = `${process.env.PUBLIC_URL}/images/${src}.gif`
    })
  }
  onZoom (e) {
    e.preventDefault()
    let zoomTo = this.scale !== 0.75 ? 0.75 : this.zoom_factor
    this.panzoom.panzoom('zoom', zoomTo, {
      animate: true,
      focal: e
    })
  }
  onResize (e) {
    this.positionLyric(this.refs.image)
  }
  positionLyric (image) {
    this.panzoom.panzoom('reset', false)
    let $image = $(ReactDOM.findDOMNode(image))

    let container_height = this.$container.height()
    let container_width = this.$container.width()
    let image_width = $image.width()
    let image_height = $image.height()
    let image_center_left = image_width / 2.0
    let image_center_top = image_height / 2.0

    this.zoom_factor = container_height / image_height
    this.panzoom.panzoom('zoom', this.zoom_factor)

    image_width *= this.zoom_factor
    image_height *= this.zoom_factor

    let image_offset_left = image_center_left - (image_width / 2.0)
    let image_offset_top = image_center_top - (image_height / 2.0)
    let new_offset_left = (container_width - image_width) / 2.0
    let new_offset_top = (container_height - image_height) / 2.0
    let pan_left = new_offset_left - image_offset_left
    let pan_top = new_offset_top - image_offset_top

    this.panzoom.panzoom('pan', pan_left, pan_top)
  }
  render () {
    let {active, animating, displayLyric} = this.props
    let {loaded, src, width, height} = this.state
    return (
      <LyricsWrapper active={active} animating={animating} displayLyric={displayLyric} ref='container'>
        {!loaded && <Loading loaded={loaded} className='loading dots' />}
        <Lyric ref='image' loaded={loaded} src={src} width={width} height={height} />
      </LyricsWrapper>
    )
  }
}

Lyrics.propTypes = {
  displayLyric: PropTypes.bool,
  enableZooming: PropTypes.bool,
  active: PropTypes.string,
  animating: PropTypes.bool,
  lyric: PropTypes.string
}

export default Lyrics



/** WEBPACK FOOTER **
 ** ./src/components/Lyrics.js
 **/